// Learn more about liceycle hook here : https://v3.vuejs.org/api/options-lifecycle-hooks.html
import { makeReport } from "../pdfJS/pdf";
export default {
  data() {
    return {
      currentModule: null,
      currentFolder: null,
      currentFile: null,
      folders: [],
      files: [],
      bValues: null,
      initScreenChangeDetection: 0,
      myParticipant: {},
      dialog: false,
      editedIndex: -1,
      eltKey: 0,

      datas: [],
      datasToShow: [],

      flipMovments: {
        movmentX: 0,
        movmentY: 0,
      },
    };
  },

  computed: {},

  methods: {
    makeReport(...ch) {
      return makeReport(...ch);
    },
    matriceTooltip(container, currElt, arr) {
      let matriceTooltip = document.createElement("div");
      matriceTooltip.classList.add("matrice-tooltip");

      arr.forEach((a) => {
        let span = document.createElement("span");
        let spanContent =
          typeof currElt[a] === "string"
            ? document.createTextNode(currElt[a])
            : document.createTextNode(currElt[a].value);

        span.classList.add("matrice-tooltip-container");
        span.appendChild(spanContent);
        matriceTooltip.appendChild(span);
      });

      container.appendChild(matriceTooltip);
    },

    constRoundDecimal(nbr, precision = 2) {
      let tmp = Math.pow(10, precision);
      return Math.round(nbr * tmp) / tmp;
    },

    /**
     * close the dialog
     */
    closeModal() {
      const elt = document.getElementById("strato-modal");

      elt.classList.remove("animate__fadeInDown");
      elt.classList.add("animate__fadeOutDown");

      setTimeout(() => {
        if (typeof this.editionActive !== "undefined")
          this.editionActive = false;

        this.dialog = false;
        this.editedIndex = -1;
        this.editedElt = Object.assign({}, this.newElt);

        elt.classList.remove("animate__fadeOutDown");
        elt.classList.add("animate__fadeInDown");
      }, 550);
    },

    /**
     * Force the required element to be reloaded
     */
    resetEltClass() {
      document.querySelectorAll(".dataFlip").forEach((elt) => {
        elt.classList.remove(
          "animate__animated",
          "animate__fadeInRight",
          "animate__fadeInDown",
          "animate__zoomIn"
        );
      });
    },

    /**
     * Animate {items} from {id} with FLIP method
     *
     * @param {HTMLElements} items all the HTMLElements that's need to be animated
     * @param {number} id The key where the animation going to be started
     */
    flip(items, id) {
      let availableItems = Array.from(items).slice(id);

      availableItems.forEach((elt, index) => {
        elt.classList.remove("animate__animated", "animate__fadeInRight");
        if (index > 0) {
          this.flipMovments.movmentX =
            parseInt(availableItems[index - 1].getBoundingClientRect().left) -
            parseInt(elt.getBoundingClientRect().left);
          this.flipMovments.movmentY =
            parseInt(availableItems[index - 1].getBoundingClientRect().top) -
            parseInt(elt.getBoundingClientRect().top);

          elt.style.transition = "all .7s ease-in-out";
          elt.style.transform =
            "translate3d(" +
            this.flipMovments.movmentX +
            "px, " +
            this.flipMovments.movmentY +
            "px, 0)";
        }
      });
    },

    /**
     * handle current targeted element to be deleted
     */
    async handleDelete(item) {
      this.editedElt = Object.assign({}, item);
      this.editedIndex = this.datas.findIndex((x) => x.name === item.name);

      const dataFlip = document.querySelectorAll(".dataFlip")[this.editedIndex];

      if (
        await this.$swal.fire({
          title: "Êtes vous sure de vouloir supprimer " + item.name,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, Supprimer",
        }).isConfirmed
      ) {
        this.flip(document.querySelectorAll(".dataFlip"), this.editedIndex);

        dataFlip.classList.add("animate__animated", "animate__fadeOutUp");

        setTimeout(() => {
          this.datas.splice(this.editedIndex, 1);
          dataFlip.style.visibility = "hidden";
          this.saveLocal();
          this.forceRerender();
        }, 650);
      }
    },

    /**
     * handle current targeted element to be edited
     */
    handleEdit(item) {
      if (typeof this.editionActive !== "undefined") this.editionActive = true;

      this.editedElt = Object.assign({}, item);
      //this.editedIndex = this.datas.findIndex( x => x.name === item.name)
      this.dialog = true;
    },

    /**
     * save & update current targeted element
     */
    handleStore() {
      if (this.editedIndex < 0) {
        this.datas.push(this.editedElt);
        this.datasToShow.push(this.editedElt);
      } else {
        this.datas[this.editedIndex] = Object.assign({}, this.editedElt);
        this.datasToShow[this.editedIndex] = Object.assign({}, this.editedElt);
      }

      setTimeout(() => {
        this.resetEltClass();
      }, 950);

      this.saveLocal();
    },

    /**
     * set the current folder and go to files path
     */
    setCurrentFolder(item) {
      localStorage.setItem("currentFolder", JSON.stringify(item));

      this.$router.push("/app/files");
    },

    handleResize() {},
  },

  watch() {},

  // Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup
  beforeCreated() {},

  // Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  // Called right before the mounting begins: the render function is about to be called for the first time.
  beforeMount() {},

  // Called after the instance has been mounted, where element, passed to app.mount is replaced by the newly created vm.$el
  // Note that mounted does not guarantee that all child components have also been mounted. If you want to wait until the entire view has been rendered, you can use vm.$nextTick inside of mounted
  mounted() {
    this.myParticipant =
      localStorage.getItem("myParticipant") !== null
        ? JSON.parse(localStorage.getItem("myParticipant"))
        : null;

    this.currentModule =
      localStorage.getItem("currentModule") !== null
        ? JSON.parse(localStorage.getItem("currentModule"))
        : null;
    this.currentFolder =
      localStorage.getItem("currentFolder") !== null
        ? JSON.parse(localStorage.getItem("currentFolder"))
        : null;
    this.currentFile =
      localStorage.getItem("currentFile") !== null
        ? JSON.parse(localStorage.getItem("currentFile"))
        : null;
    this.folders =
      localStorage.getItem("temp-folder") !== null
        ? JSON.parse(localStorage.getItem("temp-folder"))
        : null;
    this.files =
      localStorage.getItem("temp-files") !== null
        ? JSON.parse(localStorage.getItem("temp-files"))
        : null;
    //(this.currentFile = localStorage.getItem('temp-file-' + this.currentFolder.name) !== null ? JSON.parse(localStorage.getItem('temp-file-' + this.currentFolder.name)) : null)

    if (this.currentModule === null) this.$router.push("/app/tools");

    this.$nextTick(() => {
      // Code that will run only after the
      // entire view has been rendered
    });
  },

  // Called when data changes, before the DOM is patched. This is a good place to access the existing DOM before an update, e.g. to remove manually added event listeners.
  beforeUpdate() {},

  // Called after a data change causes the virtual DOM to be re-rendered and patched.
  // Note that updated does not guarantee that all child components have also been re-rendered. If you want to wait until the entire view has been re-rendered, you can use vm.$nextTick inside of updated:
  updated() {
    this.$nextTick(() => {
      // Code that will run only after the
      // entire view has been re-rendered
    });
  },

  // Called when a kept-alive component is activated
  activated() {},

  // Called when a kept-alive component is deactivated
  deactivated() {},

  // Called right before a component instance is unmounted. At this stage the instance is still fully functional.
  beforeUnmount() {},

  // Called after a component instance has been unmounted. When this hook is called, all directives of the component instance have been unbound, all event listeners have been removed, and all child component instance have also been unmounted.
  unmount() {
    window.removeEventListener("resize", this.handleResize);
  },

  // Called when virtual DOM re-render is tracked. The hook receives a debugger event as an argument
  // renderTracked ({ key, target, type }) {

  //   console.log({ key, target, type })
  // },

  // renderTriggered ({ key, target, type }) {

  //   console.log({ key, target, type })
  // }
};
